import React, { useEffect, useState } from "react";
import { PopoverDisclosure, usePopoverState } from "reakit/Popover";
import styled from "styled-components";
import { PeriodRange } from "@linkfluence/models/date";
import { Facet } from "@linkfluence/models/facet";
import { Locale } from "@linkfluence/models/locale";
import Button from "@ui-kit/button";
import Popover from "@ui-kit/popover";
import { useFacetsFromContext } from "@radarly/core/facets/use-cases";
import { tr } from "@radarly/i18n";
import { Clause } from "@radarly/models/clause";
import { getFacetFromField } from "@radarly/models/facets";
import { useIsCurrentInsightPageGlobal } from "@radarly/models/insight-pages/is";
import Panel from "./panels";
import New from "./panels/new-filters";

interface IProps {
  setClause: (clause: Clause) => void;
  usedFields: string[];
  locale?: Locale;
  period: PeriodRange;
  excludedFacets?: Facet[];
  customCategories?: Facet[];
}

const EMPTY_CLAUSE = { and: [] };

const StyledButton = styled(Button)`
  margin: 0 12px 0 6px;
  width: max-content;
`;

const RadarlySharedFilterbarNewFilter = ({
  setClause,
  usedFields,
  locale,
  period,
  excludedFacets,
  customCategories,
}: IProps) => {
  const popover = usePopoverState({ placement: "bottom-start" });
  const isGlobalPage = useIsCurrentInsightPageGlobal();
  const [field, setField] = useState(null);
  const facets = useFacetsFromContext();
  const [fieldClause, setTempClause] = useState(EMPTY_CLAUSE);
  const triggerWindowResize = () => {
    //little trick : trigger resize event so that reakit popover recalculate position
    window.dispatchEvent(new Event("resize"));
  };
  const onApplyClause = () => {
    setTempClause(EMPTY_CLAUSE);
    setClause(fieldClause);
    setField(null);
    popover.hide();
  };
  const openFieldPanel = (field: Facet) => {
    triggerWindowResize();
    setTempClause(EMPTY_CLAUSE);
    setField(field);
  };
  useEffect(() => {
    if (!popover.visible) {
      setTempClause(EMPTY_CLAUSE);
      setField(null);
    }
  }, [popover.visible]);
  const onCancelCreation = () => {
    popover.hide();
    triggerWindowResize();
    setField(null);
  };
  return (
    <>
      <PopoverDisclosure
        {...popover}
        as={StyledButton}
        text={tr(locale, "FILTERBAR::ADDFILTER")}
        size="l"
      />
      <Popover popover={popover} ariaLabel="add-filter">
        {field ? (
          <Panel
            clause={fieldClause}
            setClause={setTempClause}
            onApply={onApplyClause}
            facet={getFacetFromField(facets, field)}
            hasTitle
            onCancel={onCancelCreation}
            period={period}
          />
        ) : (
          <New
            openFieldPanel={openFieldPanel}
            usedFields={usedFields}
            showQueries={!isGlobalPage}
            excludedFacets={excludedFacets}
            customCategories={customCategories}
          />
        )}
      </Popover>
    </>
  );
};

export default RadarlySharedFilterbarNewFilter;
